import React from 'react';
import CalendarConfig from '../../../../consts/CalendarConfig';
import styles from './textBodies.module.css';
import RichTextView from '../../../rich-text/RichTextView';

/**
 * Miolo do PDF de anotações: um bloco por anotação com a data; a anotação
 * do atendimento em curso recebe a etiqueta "Deste atendimento".
 *
 * `notes`: anotações na ordem do card; `appointmentId`: atendimento atual (ou null).
 */
export const NotesReportBody = ({ notes, appointmentId }) => {
  const list = Array.isArray(notes) ? notes : [];

  return (
    <>
      {list.map((note) => {
        const isCurrent = appointmentId != null && String(note.appointmentId) === String(appointmentId);
        return (
          <div key={note.id} className={styles.record}>
            <div className={styles.recordHead}>
              <span className={styles.recordDate}>{CalendarConfig.GetDDMMAAAA(note.createdAt)}</span>
              {isCurrent && <span className={styles.tag}>Deste atendimento</span>}
            </div>
            <RichTextView value={note.note} className={styles.text} />
          </div>
        );
      })}
    </>
  );
};

export default NotesReportBody;
